module.exports = __webpack_public_path__ + "img/역삼 미용실.df8b95b1.png";